import { useMutation } from '@tanstack/react-query';
import { useAxios } from './useFetch';
import { FAST_API_URL } from 'src/config';

export const useResendVerificationEmail = () => {
  const mutationFn = useAxios<undefined, undefined>({
    endpoint: '/v1/verification-email',
    method: 'post',
    url: FAST_API_URL,
  });
  return useMutation({ mutationFn });
};

export const useCreatePasswordChangeTicket = () => {
  const mutationFn = useAxios<{ ticket: string }, undefined>({
    endpoint: '/v1/password-change-ticket',
    method: 'post',
    url: FAST_API_URL,
  });
  return useMutation({ mutationFn });
};
